import { WidgetViewExtension } from '@blocksuite/std';
import { literal, unsafeStatic } from 'lit/static-html.js';

import { HIVE_DOC_REMOTE_SELECTION_WIDGET } from './doc';
import { HIVE_EDGELESS_REMOTE_SELECTION_WIDGET } from './edgeless';

export * from './doc';
export * from './edgeless';

export const docRemoteSelectionWidget = WidgetViewExtension(
  'hive:page',
  HIVE_DOC_REMOTE_SELECTION_WIDGET,
  literal`${unsafeStatic(HIVE_DOC_REMOTE_SELECTION_WIDGET)}`
);

export const edgelessRemoteSelectionWidget = WidgetViewExtension(
  'hive:page',
  HIVE_EDGELESS_REMOTE_SELECTION_WIDGET,
  literal`${unsafeStatic(HIVE_EDGELESS_REMOTE_SELECTION_WIDGET)}`
);
